import { render, staticRenderFns } from "./partner-wallet.vue?vue&type=template&id=7abef891&scoped=true&"
import script from "./partner-wallet.vue?vue&type=script&lang=js&"
export * from "./partner-wallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abef891",
  null
  
)

export default component.exports